import React from 'react';
import { images } from '../data/content';
import { OfferCard } from './OfferCard';
import { TrustRow } from './TrustRow';
export function FinalCta() {
  return <section id="cierre" aria-labelledby="cierre-titulo" className="relative isolate scroll-mt-8 overflow-hidden bg-ink-900" data-id="element-62" data-mp="vhajid21if0t">
      <img src={images.courtBg} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" data-id="element-63" data-mp="15dlt2va8wqrk" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(37,89,232,0.35),transparent_65%)]" data-id="element-64" data-mp="1jc3eunglbt6u" />

      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:py-24" style={{
      paddingTop: "11px",
      paddingBottom: "17px"
    }} data-id="element-65" data-mp="1ebxtfp0wz2x7">
        <h2 id="cierre-titulo" className="font-display text-3xl uppercase leading-tight text-white sm:text-5xl" style={{
        fontSize: "24px"
      }} data-id="element-66" data-mp="1o4wj7a85czie">
          Tu próximo fin de semana
          <span className="block text-ball-400" data-id="element-67" data-mp="1x5b6ug8l2qp2">puede ser diferente</span>
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-300" style={{
        fontSize: "15px",
        paddingTop: "28px",
        marginTop: "-20px",
        marginBottom: "-20px"
      }} data-id="element-68" data-mp="n64bhobvbslx">
          Sigma Smart es el sistema completo para monitores de pádel que quieren trabajar con más orden, evidencia y libertad. Porque enseñar pádel no debería costarte todos los fines de semana del año.
        </p>

        <OfferCard className="mt-10" ctaLabel="👉 Descargar el pack completo ahora — 19 €" data-id="element-69" data-mp="163p1wzua6z8n" />

        <p className="mt-8 font-display text-lg uppercase text-court-200 sm:text-xl" data-id="element-70" data-mp="1b28p13km2h2l">
          “Tu próxima sesión puede ser la mejor que hayas dado.” ⚡
        </p>

        <TrustRow className="mt-10" data-id="element-71" data-mp="1kt38k06h32kc" />
      </div>
    </section>;
}